import React from "react";
import "./produklistcom.scss";
import datacom from "./datacom.json";
import Card from "../../../Component/Card/card";
import Theloopimages from "../../../Media/Ruko BSD/The Loop/Theloop";
import westvillageimages from "../../../Media/Ruko BSD/West Village/westvillage";
import Northridgeimages from "../../../Media/Ruko BSD/Northridge/Northridge";
import Iconiximages from "../../../Media/Ruko BSD/Iconix/Iconix";
import Capitalcoveimages from "../../../Media/Ruko BSD/Capital Cove/Capitalcove";
import NavaparkBusinessimages from "../../../Media/Ruko BSD/Navapark Business Suites/NavaparkBusiness";

import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faChevronRight} from "@fortawesome/free-solid-svg-icons";

const imageMap = {
  Theloopimages,
  westvillageimages,
  Northridgeimages,
  Iconiximages,
  Capitalcoveimages,
  NavaparkBusinessimages,

  // Add other image arrays here if you have more sets
};

const produk = () => {
  return (
    <div id="Bestbuying" className="produk">
      <h1>Fullfill your Business Needs</h1>
      <h2>Our Choice of Commercials Buildings</h2>
      <div className="cardhome-container">
        {datacom.cards.map((card, index) => {
          // Determine the logo dynamically
          // Determine the logo dynamically
          return (
            <Card
              key={index}
              carousel={imageMap[card.imagesKey]}
              title={card.title}
              subtitle={card.subtitle}
              price={card.price}
              subprice={card.subprice}
              details={card.details}
              whatsappLink={card.whatsappLink} // Pass the WhatsApp link
            />
          );
        })}
      </div>
      <div className="clusterbuttoncom">
        <a href="/Commercial">
          <button className="pagelinkcom">
            Pilihan Lainnya&nbsp;
            <FontAwesomeIcon icon={faChevronRight} />
          </button>
        </a>
      </div>
    </div>
  );
};

export default produk;
